module.exports = __webpack_public_path__ + "static/img/clickin511.32fd9b36.png";